import { render, staticRenderFns } from "./AppDashboard.vue?vue&type=template&id=8d89aae8&scoped=true"
import script from "./AppDashboard.js?vue&type=script&lang=js&external"
export * from "./AppDashboard.js?vue&type=script&lang=js&external"
import style0 from "./AppDashboard.vue?vue&type=style&index=0&id=8d89aae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d89aae8",
  null
  
)

export default component.exports